import { Typography } from "antd";
import React from "react";

const { Title, Text } = Typography;

export interface PageHeaderProps {
  /** The page's name. Rendered as a level-3 heading — every page in both apps uses the same weight. */
  title: React.ReactNode;
  /** Optional one-line subtitle. Omit rather than pad it with a reference code or breadcrumb trail — use `extra` or a `Text type="secondary"` breadcrumb above the header for that. */
  description?: React.ReactNode;
  /** Right-aligned actions (buttons, a project picker, ...) rendered level with the title. */
  extra?: React.ReactNode;
}

/**
 * Standard page-level header, shared by MJ-Extended-PM and MJ-Tracker so every
 * page presents its title at the same visual weight. Render it as the first
 * element inside a page's content — it does not wrap children or provide a
 * background, that comes from the app's `Layout`.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  extra
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 16,
      marginBottom: 24
    }}
  >
    <div>
      <Title level={3} style={{ marginBottom: description ? 4 : 0 }}>
        {title}
      </Title>
      {description && <Text type="secondary">{description}</Text>}
    </div>
    {extra && <div>{extra}</div>}
  </div>
);
